// istanbul ignore file

import { createReducer, on } from '@ngrx/store'
import { AppActions } from './app.actions'

export interface AppStoreState {
  noticeVisible: boolean
  cardMenuVisible: boolean
  paymentAvailable: boolean
}

export const initialState: AppStoreState = { noticeVisible: true, cardMenuVisible: false, paymentAvailable: false }

export const appReducer = createReducer(
  initialState,
  on(AppActions.showNotice, state => ({ ...state, noticeVisible: true })),
  on(AppActions.hideNotice, state => ({ ...state, noticeVisible: false })),
  on(AppActions.hideCardMenu, state => ({ ...state, cardMenuVisible: false })),
  on(AppActions.showCardMenu, state => ({ ...state, cardMenuVisible: true })),
)
